import { useEffect, useState } from "react";

const navItems = [
  { label: "Processing", href: "#processing" },
  { label: "Services", href: "#services" },
  { label: "Area", href: "#service-area" },
  { label: "Travel", href: "#travel-timing" },
  { label: "Destinations", href: "#destinations" },
  { label: "Facilities", href: "#acceptance-facilities" },
  { label: "Compare", href: "#comparison" },
  { label: "FAQ", href: "#faq" },
  { label: "Resources", href: "#local-resources" },
];

export default function HollywoodStickyNav() {
  const [active, setActive] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(`#${entry.target.id}`);
          }
        });
      },
      { rootMargin: "-45% 0px -45% 0px" }
    );
    navItems.forEach((item) => {
      const el = document.querySelector(item.href);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm hidden md:block">
      <div className="max-w-7xl mx-auto px-4 md:px-8 overflow-x-auto">
        <div className="flex items-center gap-1 py-3 min-w-max">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3.5 py-2 rounded-md text-xs font-semibold transition-all whitespace-nowrap ${
                active === item.href
                  ? "bg-[#1A365D] text-white"
                  : "text-gray-500 hover:text-[#1A365D] hover:bg-gray-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}